import React from "react";
import PropTypes from "prop-types";
import { DownIcon, UpIcon } from "./Icons";
import { FeedbackIcon } from "../FeedbackIcon";

import { NativeDropdown } from "@learningblocks/storybook-components/lib/NativeDropdown";

export function DropdownCell(props) {
  const { cellHeight } = props;

  const onChange = ({ value }) => {
    props.onChange({
      id: props.id,
      value,
      answer: props.answer,
      numberOfInputs: props.numberOfInputs,
      feedback: props.feedback,
      unique: props.unique,
      options: props.options,
    });
  };

  const setClassName = () => {
    let className = props.className;
    if (props.showFeedback) {
      className += ` ${props.isCorrect ? "correctOption" : "incorrectOption"}`;
    }
    return className;
  };

  return (
    <td className={setClassName()} colspan={props.colspan}>
      <div className={`dataTable_row_cell_contents`}>
        <NativeDropdown
          placeholder={props.placeholder}
          className={`${props.className}_dropdown`}
          options={props.options}
          value={props.value}
          onChange={onChange}
          disabled={props.disabled}
          iconOpen={DownIcon}
          iconClose={UpIcon}
          cellHeight={cellHeight}
        />
        <FeedbackIcon
          isSuccess={props.isCorrect}
          showFeedback={props.showFeedback}
          className={`${props.className}_feedback`}
          feedback={props.feedback}
        />
      </div>
    </td>
  );
}

DropdownCell.propTypes = {
  /**
   * Unique Id for the cell
   */
  id: PropTypes.string,
  /**
   * placeholder for the cell
   */
  placeholder: PropTypes.string,
  /*
   * className to be set on component
   */
  className: PropTypes.string,
  /**
   * Options associated with drodown
   */
  options: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * value of the option
       */
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      /**
       * Label for option
       */
      label: PropTypes.string,
    })
  ),
  /*
   * Currently selected option value
   */
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Funciton to invoke when an option is selected
   */
  onChange: PropTypes.func,
  /**
   * Boolean to check if the dropdown is disabled
   */
  disabled: PropTypes.bool,
  /**
   * Boolean feedback on value being correct/incorrect
   */
  isCorrect: PropTypes.bool,
  /**
   * Boolean to check if answer value is unique in table
   */
  unique: PropTypes.bool,
};
